import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import {
  useV2GetAccountQuery,
  useV2GetProjectByIdQuery,
} from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import React from "react";
import { Edit } from "./Edit";
import { Route, Routes } from "react-router";
import Show from "./Show/Show";

function ProjectVersionsV2Mspa({ account_slug, project_id }) {
  // Get Account
  const {
    data: account,
    error: accountError,
    isLoading: accountLoading,
    refetch: accountRefetch,
  } = useV2GetAccountQuery({
    include: ["phases", "resources"],
  });

  // Get permissions for current user
  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const {
    data: project,
    error: projectError,
    isLoading: projectLoading,
    refetch: projectRefetch,
  } = useV2GetProjectByIdQuery({ id: String(project_id) });

  const auditLogPermission: string = accessLevel("projects.versions") || "";

  const authorized = useAuthorization();
  if (
    !authorized ||
    !user ||
    privilegesLoading ||
    !project ||
    projectLoading
  ) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            auditLogPermission={auditLogPermission}
            projectLoading={projectLoading}
            currentUserLoading={privilegesLoading}
            project={project}
            account={account?.data}
          />
        }
      />
      <Route
        path="/:versionId/edit"
        element={
          <Edit
            auditLogPermission={auditLogPermission}
            project={project}
            account={account?.data}
          />
        }
      />
    </Routes>
  );
}

export default ProjectVersionsV2Mspa;
